enum OrderSearchColEnum {
    VENDOR = "VENDOR",
    CLIENT = "CLIENT",
    ORDER = "ORDER",
    PO = "PO",
    DESCRIPTION = "DESCRIPTION",
    SHIP_DATE_RANGE = "SHIP_DATE_RANGE",
    LAST_UPDATED = "LAST_UPDATED",
    STATUS = "STATUS",
    FILTER_PRELIMINARY = "FILTER_PRELIMINARY",
    REMAKE = "REMAKE",
    EXPEDITED = "EXPEDITED",
    PERCENTAGE_FILLABLE = "PERCENTAGE_FILLABLE",
    THIRD_PARTY_ORDER_REF = "THIRD_PARTY_ORDER_REF",
    ORDER_CATEGORY = "ORDER_CATEGORY",
    CUSTOM = "CUSTOM",
    ACCOUNTING = "ACCOUNTING",
    QBO_INVOICE_CREATED = "QBO_INVOICE_CREATED",
    QBO_INVOICE_EMAILED = "QBO_INVOICE_EMAILED",
    CATALOG = "CATALOG",
    OLDER_THREE_MONTHS = "OLDER_THREE_MONTHS",
}

export default OrderSearchColEnum;
